import { getSuarteEnvironment } from "./environment.utils";

export default function detectStandaloneVisit(options = {}) {
  const { requireNativeMarker = false } = options;
  if (typeof window === "undefined") {
    return false;
  }

  const environment = getSuarteEnvironment();

  let hasExplicitParam = false;
  try {
    const params = new URLSearchParams(window.location?.search ?? "");
    const markers = ["app", "app_shell", "display", "display_mode", "standalone"];
    hasExplicitParam = markers.some((key) => {
      const value = params.get(key);
      if (!value) {
        return false;
      }
      const normalized = value.toLowerCase();
      return (
        normalized === "1" ||
        normalized === "true" ||
        normalized === "app" ||
        normalized === "standalone"
      );
    });
  } catch (_error) {
    hasExplicitParam = false;
  }

  if (requireNativeMarker) {
    return Boolean(
      environment.isNativeWrapper ||
      environment.isAndroidTWA ||
      hasExplicitParam
    );
  }

  return Boolean(
    environment.isApp ||
    hasExplicitParam ||
    environment.isAndroidTWA
  );
}
